module.exports = __webpack_public_path__ + "static/PFM03-d6268a0eda8199de6e5af9996152b28a.jpg";